import React from 'react';
import ReactDOM from 'react-dom';
import { getReportCoverConfig } from 'configs';
import _e from 'common/localeUtil';
import ConfigSectionPanel from '../ConfigSectionPanel';

const CustomComponent = editor => {
	const domComponents = editor.DomComponents;
	domComponents.addType('section-type', {
		extend: 'div',
		isComponent: el => el.classList?.contains('section'),
		extendFn: ['init'],
		extendFnView: ['onRender'],
		model: {
			defaults: {
				draggable: 'body', // Can be dropped only inside `form` elements
				droppable: false, // Can't drop other elements inside,
				attributes: {
					'data-layout-col': 3,
					'data-max-col': 5,
					'data-layoutable-disabled': false,
					'data-configurable-disabled': false,
					'data-background-edit-disabled': false
				},
				traits: []
			},
			init() {
				this.on('change:attributes:data-layout-col', this.handleLayoutChange);
			},
			handleLayoutChange() {
				const {
					'data-layout-col': layoutCol,
					'data-layoutable-disabled': layoutableDisabled
				} = this.getAttributes();
				if (layoutableDisabled) {
					return;
				}
				const components = this.find('.layoutable > .column');
				const layoutClasses = [
					'is-full',
					'is-half',
					'is-one-third',
					'is-3',
					'is-one-fifth',
					'line-end'
				];
				const endIndex = components.length - 1;
				components.forEach((comp, index) => {
					const hasLineEnd =
						layoutCol > 0 && (index === endIndex || (index + 1) % layoutCol === 0);
					const newClasses = comp
						.getClasses()
						.filter(c => !layoutClasses.includes(c))
						.concat([layoutClasses[layoutCol - 1], hasLineEnd ? 'line-end' : ''])
						.join(' ');
					comp.setClass(newClasses);
				});
			}
		},
		view: {
			onRender(component) {
				const { el, model } = component;
				const {
					layoutableDisabled,
					configurableDisabled,
					backgroundEditDisabled
				} = el.dataset;
				const buttonDiv = document.createElement('div');
				buttonDiv.classList.add('editor-button-row');
				const layoutable =
					!layoutableDisabled &&
					(((el.id === 'section-services' ||
						el.id === 'section-accolades' ||
						el.id === 'section-videos') &&
						!!el.querySelector('.layoutable')) ||
						el.id === 'section-calculator');

				ReactDOM.render(
					<ConfigSectionPanel
						selectedComponent={component}
						editor={editor}
						configurable={!configurableDisabled}
						layoutable={layoutable}
						backgroundEditable={!backgroundEditDisabled}
					/>,
					buttonDiv
				);
				el.append(buttonDiv);
				if (!layoutableDisabled) {
					model.handleLayoutChange();
				}
			}
		}
	});

	domComponents.addType('cover-page-background', {
		extend: 'div',
		extendFnView: ['onRender'],
		extendFn: [],
		isComponent: el => el.classList?.contains('cover-page-background'),
		view: {
			onRender(component) {
				const configs = getReportCoverConfig(window.selectedTemplate);
				const { el } = component;
				const buttonDiv = document.createElement('div');
				buttonDiv.classList.add(
					'editor-button-row',
					'report',
					`pos-${configs.bgConfigPosition}`
				);
				ReactDOM.render(
					<ConfigSectionPanel
						selectedComponent={component}
						editor={editor}
						configurable={false}
						layoutable={false}
						backgroundEditable
					/>,
					buttonDiv
				);
				el.append(buttonDiv);
			}
		}
	});

	domComponents.addType('unchangeable', {
		extend: 'text',
		extendFnView: ['onRender'],
		extendFn: [],
		view: {
			onRender({ el, model }) {
				el.oninput = function() {
					el.innerHTML = model.attributes.content;
				};
			}
		}
	});

	const layoutableAddButtonCommandMaps = {
		'service-item-add-button': 'createServiceItem',
		'accolade-item-add-button': 'createAccoladeItem',
		'video-item-add-button': 'createVideoItem',
		'widget-item-add-button': 'createWidgetItem'
	};
	const layoutableClasses = Object.keys(layoutableAddButtonCommandMaps);
	domComponents.addType('layoutable-add-item-button', {
		extend: 'div',
		isComponent: el => {
			if (!el?.classList) {
				return false;
			}
			return layoutableClasses.find(className => el.classList.contains(className));
		},
		extendFn: [],
		model: {
			defaults: {
				tagName: 'div',
				droppable: false,
				attributes: {},
				highlightable: false,
				removable: false,
				draggable: false,
				badgable: false,
				copyable: false,
				resizable: false,
				editable: false,
				layerable: false,
				selectable: false,
				hoverable: false,
				traits: []
			}
		},
		extendFnView: ['onRender'],
		view: {
			onRender({ el }) {
				const buttonDiv = document.createElement('div');
				buttonDiv.classList.add('editor-button-row', 'layoutable-button');
				const buttonTypeClass = layoutableClasses.find(className =>
					el.classList.contains(className)
				);
				const commandName = layoutableAddButtonCommandMaps[buttonTypeClass];
				if (commandName) {
					const btn = document.createElement('button');
					btn.innerText = _e('add_item');
					btn.classList.add('editor-button', 'add-item-button');
					const handleCallback = () => {
						editor.runCommand(commandName, {
							sectionId: `#${el.id}`
						});
					};
					btn.addEventListener('click', handleCallback);
					btn.addEventListener('touchstart', handleCallback);

					buttonDiv.appendChild(btn);

					el.append(buttonDiv);
				}
			}
		}
	});
};

export default CustomComponent;
